import { useCallback } from "react";

import { useTranslations } from "@ui/providers/useTranslations";

import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";

import type { Question } from "../SobQuiz.types";

export const useQuizTracking = () => {
  const { __ } = useTranslations();

  const trackQuizProgress = useCallback(
    async (step: number, currentQuestion?: Question, selectedAnswer?: string, consentName?: string) => {
      try {
        if (step === 1 && consentName) {
          await dispatchTrackingEvent(TrackingEvents.TrackingSurveyStart, {
            survey_question: consentName,
            survey_answer: selectedAnswer ? __("sob.consent.yes") : __("sob.consent.no"),
          });
          return;
        }

        const surveyQuestion = currentQuestion?.question.title ?? "";
        const surveyAnswer =
          currentQuestion?.possibleAnswers.find((a) => a.id === selectedAnswer)?.localTranslation || "";

        if (step <= 1) {
          await dispatchTrackingEvent(TrackingEvents.TrackingSurveyStart, {
            survey_question: surveyQuestion,
            survey_answer: surveyAnswer,
          });
        } else {
          await dispatchTrackingEvent(TrackingEvents.TrackingSurveyProgress, {
            survey_question: surveyQuestion,
            survey_answer: surveyAnswer,
            survey_step_number: `${step}`,
          });
        }
      } catch (error) {
        console.error("Failed to track quiz progress:", error);
      }
    },
    []
  );

  const trackQuizCompletion = useCallback(async () => {
    try {
      await dispatchTrackingEvent(TrackingEvents.TrackingSurveyCompletion);
    } catch (error) {
      console.error("Failed to track quiz completion:", error);
    }
  }, []);

  return {
    trackQuizProgress,
    trackQuizCompletion,
  };
};
